export default __webpack_public_path__ + "achievement-small.b37e2727b2e4920c.svg";